'use strict';

import React from 'react';
import * as d3request from 'd3-request';

class WemfTracking extends React.Component {

  constructor(state) {
    super(state);

    this.state = {
      ... state,
      wemfurls: []
    }
  }

  componentDidMount() {

    let hostname = window.location.hostname;

    // to avoid a error message on localhost
    if (hostname == 'localhost') {
      //hostname = 'www.tagesanzeiger.ch';
      return;
    }

    hostname =
      hostname.substring(hostname.lastIndexOf('.',
          hostname.lastIndexOf('.') - 1) + 1); // extract domain name from host
                                               // (crops subdomains like
                                               // interaktiv.)

    d3request.json('http://www.' + hostname + '/api/sites/default')
      .get((error, siteData) => {

      let urlList = [];

      for (var i = 0; i < siteData.site.statistics.length; i++) {

        var url = siteData.site.statistics[i].desktop_url;
        url = url + 'interactive/' + this.props.projectId;

        urlList.push(url);
      }

      this.setState({wemfurls: urlList});

    });
  }


  render() {

    let pixels = [];

    this.state.wemfurls.map((url) => {
      pixels.push(<img
        src={`${url}?r=${encodeURIComponent(document.referrer)}&d=${Date.now()}`}
        width='1' height='1'
        style={{position: 'absolute', visibility: 'hidden'}} key={url}/>);
    });

    return (
      <span>{pixels}</span>
    )
  }
}

WemfTracking.propTypes = {
  projectId: React.PropTypes.string
};

WemfTracking.defaultProps = {
  projectId: 'default-project'
};

export default WemfTracking;



/** WEBPACK FOOTER **
 ** ./src/components/wemftracking/WemfTracking.js
 **/